var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4003 4.79992C12.7769 4.29854 13 3.67533 13 3C13 1.34315 11.6569 0 10 0C8.34315 0 7 1.34315 7 3C7 3.67533 7.22314 4.29854 7.59972 4.79992C7.35847 4.98116 7.13838 5.18905 6.94382 5.41921C6.67333 4.04031 5.45815 3 4 3C2.34315 3 1 4.34315 1 6C1 6.67533 1.22314 7.29854 1.59972 7.79992C0.628321 8.5297 0 9.69147 0 11V15C0 15.5523 0.447715 16 1 16H7C7.55228 16 8 15.5523 8 15V13H13C13.5523 13 14 12.5523 14 12V8C14 6.69147 13.3717 5.5297 12.4003 4.79992ZM6 11C6 9.89543 5.10457 9 4 9C2.89543 9 2 9.89543 2 11V14H6V11ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.2d11d5fe3c8f630a12da3f8354f56821.svg";
export { ForwardRef as ReactComponent };